/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthEmailControllerVerifyCodeMutationRequest,
  TelegramAuthEmailControllerVerifyCodeMutationResponse,
  TelegramAuthEmailControllerVerifyCode400,
  TelegramAuthEmailControllerVerifyCode401,
  TelegramAuthEmailControllerVerifyCode403,
  TelegramAuthEmailControllerVerifyCode429,
} from '../types/TelegramAuthEmailControllerVerifyCode.ts';

function getTelegramAuthEmailVerifyCodeUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/email/verify-code` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/email/verify-code}
 */
export async function telegramAuthEmailVerifyCode(
  data: TelegramAuthEmailControllerVerifyCodeMutationRequest,
  config: Partial<RequestConfig<TelegramAuthEmailControllerVerifyCodeMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthEmailControllerVerifyCodeMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthEmailControllerVerifyCode400
      | TelegramAuthEmailControllerVerifyCode401
      | TelegramAuthEmailControllerVerifyCode403
      | TelegramAuthEmailControllerVerifyCode429
    >,
    TelegramAuthEmailControllerVerifyCodeMutationRequest
  >({ method: 'POST', url: getTelegramAuthEmailVerifyCodeUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
